import React, { Fragment } from 'react';
import classNames from 'classnames';
import { DEFAULT_TAG } from 'data/global';

import './MentionElement.styles.scss';

type MentionElementProps = {
  className?: string;
  character: string;
} & Record<string, any>;

const MentionElement: React.FC<MentionElementProps> = (props) => {
  const { children, className, character, ...rest } = props;

  const classes = classNames('mention-element', className);

  return (
    <span {...rest} className={classes} contentEditable={false}>
      <span contentEditable={false}>
        <Fragment>
          {DEFAULT_TAG}
          {character}
          {children}
        </Fragment>
      </span>
    </span>
  );
};

export default MentionElement;
